<template>
  <el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
      <navigator></navigator>
    </el-col>
    <el-col v-if="!hasSpeedupCourse && !hasVocationalTrainingCourse" :span="20"
      class="backgroud-gray cs-fullHeight cs-main-right-container">
      <div class="cs-fullHeight cs-contentContainer-right">
        <div class="text-center backgroud-white cs-fullHeight main-content-container">
          <div class="image-container">
            <img src="../assets/warning.png">
          </div>
          <div class="content-container">
            <span>本学期您尚未报名任何课程</span>
            <br />
            <span>如有疑问，请查询客服</span>
            <br />
            <span></span>
          </div>
        </div>
      </div>
    </el-col>
    <el-col v-if="hasSpeedupCourse || hasVocationalTrainingCourse" :span="20"
      class="backgroud-gray cs-fullHeight cs-main-right-container">
      <div class="cs-fullHeight cs-contentContainer-right">
        <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
          <el-row class="cs-signCourse-header">
            <el-col>
              <span class="cs-title">{{isOnline ? "线上课流程" : "上课签到"}}</span>
              <el-row>
                <el-col>
                  <span class="cs-classin-step">第一步</span>
                  <br />
                  如果您是速成新学员或者从未通过ClassIn上过速成网课，请点击下方链接下载并安装ClassIn客户端，
                  <span class="cs-classin-step">下载完无需注册</span>
                  <br />
                  <el-button type="text" @click="onClickClassIn" >下载ClassIn</el-button>
                  <!-- <a href="https://www.eeo.cn/cn/download.html" target="_blank">下载ClassIn</a> -->
                  <!-- <a class="cs-classin-applink" href="http://download.eeo.cn/classin_win_install_3.1.0.213h2_s.exe" target="_blank">PC端</a>    
                                <a class="cs-classin-applink" href="http://download.eeo.cn/classin_mac_install_3.1.0.213h2_s.dmg" target="_blank">Mac端</a> -->
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <span class="cs-classin-step">第二步</span>
                  <br />
                  <span>当指定时间课程激活时，点击“开始上课”即可进入教室</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <span class="cs-classin-step">注意事项</span>
                  <br />
                  为保证同学和老师的上课质量，请准时进入教室。系统将如实记录每位同学的出勤情况。<br />
                  凡迟到或者早退<span class="cs-classin-step">45分钟</span>以上的同学，该节课程将被记为<span class="cs-classin-step">旷课</span>。
                  <!-- 旷课的课程在回看视频时可能会产生一些<span class="cs-classin-step">费用</span>。 -->
                </el-col>
              </el-row>
              <el-row class="grid-content" v-if="hasSpeedupCourse">
                <el-col>
                  <el-row>
                    <el-col>
                      <div>
                        <span>学校：</span>
                        <span>{{university.UniversityName}}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <div>
                        <span>学期：</span>
                        <span>{{currentTerm.DisplayLable}}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <course-operator :courseList="courseList" :usage='"student"'></course-operator>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row class="grid-content" v-if="hasVocationalTrainingCourse" style="margin-top:50px">
                <el-col>
                  <el-row>
                    <el-col>
                      <course-operator :courseList="vocationalTrainingList" :usage='"studentVocationalTraining"'>
                      </course-operator>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.main-content-container {
  padding-top: 80px;
  .content-container {
    margin-top: 20px;
  }
}

.cs-classin-step {
  font-weight: bold;
}
.cs-classin-applink {
  display: inline-block;
  margin-right: 20px;
}
.cs-signCourse-header {
  margin-bottom: 20px;
}
</style>

<script>
import global_ from "../core/global";
import navigator from "../components/navigator";
import courseOperator from "../components/courseOperator";
import { getCurrentTerm, getUniversities } from "../service/common.service";
import {
  getStudent,
  getStudentActiveCourses,
  getStudentVocationalTrainingActiveCourses,
} from "../service/student.service";
import { getStore, isSafari } from "../config/mUtils";
export default {
  data() {
    return {
      isOnline: global_.isOnlineCourse,
      hasSpeedupCourse: true,
      hasVocationalTrainingCourse: false,
      university: {
        UniversityName: "",
        UniversityId: 0,
      },
      currentTerm: {},
      courseList: [],
      vocationalTrainingList: [],
    };
  },
  components: {
    navigator,
    courseOperator,
  },
  created() {
    getCurrentTerm().then((result) => {
      if (!!result && result.success) {
        this.currentTerm = result.data;
      }
    });
    getStudent(getStore("user_student_id")).then((result) => {
      if (!!result && result.success) {
        this.university.UniversityName = result.data.UniversityName;
        this.university.UniversityId = result.data.UniversityId;
      }
    });
    this.loadStudentActiveCourses();
    this.loadStudentVocationalTrainingActiveCourses();
  },
  methods: {
    loadStudentActiveCourses() {
      getStudentActiveCourses().then((result) => {
        if (!!result && result.success) {
          this.courseList = result.data;
          if (!this.courseList || this.courseList.length == 0) {
            this.hasSpeedupCourse = false;
          } else {
            this.hasSpeedupCourse = true;
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    loadStudentVocationalTrainingActiveCourses() {
      getStudentVocationalTrainingActiveCourses().then((result) => {
        if (!!result && result.success) {
          this.vocationalTrainingList = result.data;
          if (
            !this.vocationalTrainingList ||
            this.vocationalTrainingList.length == 0
          ) {
            this.hasVocationalTrainingCourse = false;
          } else {
            this.hasVocationalTrainingCourse = true;
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    onClickClassIn() {
      let href = "https://www.eeo.cn/cn/download.html";
      let safari = isSafari();
      if (safari) {
        window.open(href, "_blank");
      } else {
        var link = document.createElement("a");
        link.href = href;
        link.target = "_blank";
        link.click();
        window.setTimeout(() => {
          //释放内存
          window.URL.revokeObjectURL(link.href);
        }, 1000);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/signCourse.vue